import React, { useState } from 'react';
import Modal from '@/components/ui/Modal';
import Button from '@/components/ui/Button';
import { FormField } from '@/components/ui';

export const EditProjectValueModal = ({ isOpen, onClose, execution, onSave, isLoading }) => {
  const [projectValue, setProjectValue] = useState(execution?.projectValue || execution?.leadId?.quotationAmount || execution?.leadId?.budget || 0);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(execution._id, Number(projectValue));
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Edit Project Value"
      size="md"
    >
      <form onSubmit={handleSubmit} className="p-4 space-y-4">
        <FormField
          label="Total PO Value (₹)"
          type="number"
          value={projectValue}
          onChange={(e) => setProjectValue(e.target.value)}
          placeholder="Enter project value"
          required
        />
        <div className="flex justify-end gap-3 pt-4 border-t">
          <Button variant="outline" type="button" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" isLoading={isLoading}>
            Save
          </Button>
        </div>
      </form>
    </Modal>
  );
};
